/* Oendies service- en contentpagina's:
   - <oendies-page-content>: inhoudsopgave uit de koppen van de pagina-tekst, brede tabellen scrollbaar maken;
   - <oendies-levels>: tabbladen voor de absorptieniveaus (Hoe werkt het);
   - <oendies-hub-triage>: de vier vragen op de urineverlies-hub, met een passende vervolgpagina. */
(() => {
  const DESKTOP = window.matchMedia('(min-width: 990px)');

  const slug = (text, used) => {
    const base =
      String(text)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60) || 'kop';
    let id = base;
    let n = 2;
    while (used.has(id) || document.getElementById(id)) id = `${base}-${n++}`;
    used.add(id);
    return id;
  };

  if (!customElements.get('oendies-page-content')) {
    class OendiesPageContent extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-oep-body]');
        if (!this.body) return;
        this.wrapTables();
        this.buildToc();
      }

      wrapTables() {
        this.body.querySelectorAll('table').forEach((table) => {
          if (table.closest('.oep-table-wrap') || table.querySelector('img')) return;
          const cols = table.rows[0] ? table.rows[0].cells.length : 0;
          if (cols < 3) return;
          const wrap = document.createElement('div');
          wrap.className = 'oep-table-wrap';
          table.parentNode.insertBefore(wrap, table);
          wrap.appendChild(table);
        });
      }

      buildToc() {
        const toc = this.querySelector('[data-oep-toc]');
        if (!toc) return;
        const min = Number(toc.dataset.min || 3);
        const heads = [...this.body.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim().length > 1);
        if (heads.length < min) return;
        const hasH2 = heads.some((h) => h.tagName === 'H2');
        const used = new Set();
        const list = toc.querySelector('ol');
        heads.forEach((head) => {
          if (!head.id) head.id = slug(head.textContent, used);
          const li = document.createElement('li');
          if (hasH2 && head.tagName === 'H3') li.className = 'is-sub';
          const a = document.createElement('a');
          a.href = `#${head.id}`;
          a.textContent = head.textContent.trim();
          li.appendChild(a);
          list.appendChild(li);
        });
        toc.hidden = false;
        this.querySelector('.oep-page__layout')?.classList.add('oep-page__layout--toc');
        const sync = () => {
          if (DESKTOP.matches) toc.open = true;
        };
        sync();
        DESKTOP.addEventListener('change', sync);
        toc.addEventListener('click', (event) => {
          if (event.target.closest('a') && !DESKTOP.matches) toc.open = false;
        });
      }
    }
    customElements.define('oendies-page-content', OendiesPageContent);
  }

  if (!customElements.get('oendies-levels')) {
    class OendiesLevels extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
          if (panel) panel.hidden = !on;
        });
      }
    }
    customElements.define('oendies-levels', OendiesLevels);
  }

  if (!customElements.get('oendies-hub-triage')) {
    class OendiesHubTriage extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-hub-run]')?.addEventListener('click', () => this.run());
      }

      value(name) {
        return this.querySelector(`input[name="${name}"]:checked`)?.value || '';
      }

      run() {
        let routes = {};
        try {
          routes = JSON.parse(this.querySelector('[data-hub-routes]')?.textContent || '{}');
        } catch (error) {
          routes = {};
        }
        const [v1, v2, v3, v4] = ['q1', 'q2', 'q3', 'q4'].map((name) => this.value(name));
        let key = 'general';
        let extra = null;
        if (v4 === 'yes') key = 'emergency';
        else if (v3 === 'yes' || (v1 === 'yes' && v2 === 'yes')) key = 'mixed';
        else if (v1 === 'yes') key = 'stress';
        else if (v2 === 'yes') {
          key = 'urge';
          extra = 'overactive';
        }
        const box = this.querySelector('[data-hub-result]');
        const text = this.querySelector('[data-hub-result-text]');
        const links = this.querySelector('[data-hub-result-links]');
        if (!box || !text || !links) return;
        text.textContent = routes[key]?.outcome || '';
        links.replaceChildren();
        [key, extra].filter(Boolean).forEach((k) => {
          const route = routes[k];
          if (!route || !route.url || !route.label) return;
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = route.url;
          a.textContent = `${route.label} →`;
          li.appendChild(a);
          links.appendChild(li);
        });
        box.hidden = false;
        box.focus({ preventScroll: true });
        box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
    customElements.define('oendies-hub-triage', OendiesHubTriage);
  }
})();
